var map = {
	"./Average_1.png": "6035",
	"./Happy_1.png": "98d0",
	"./Sad_1.png": "f19c",
	"./VeryHappy_1.png": "7ea6",
	"./VerySad_1.png": "c2eb",
	"./data-visualization.png": "77bc",
	"./logo.png": "cf05",
	"./neutral.png": "5fe8",
	"./sad.png": "b92b",
	"./smile.png": "84b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9142";